// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.send-message-dialog[data-v-07e47972]{padding-bottom:calc(3*var(--default-grid-baseline))}`, "",{"version":3,"sources":["webpack://./src/components/BreakoutRoomsEditor/SendMessageDialog.vue"],"names":[],"mappings":"AACA,sCACC,mDAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
